import React, { Dispatch, SetStateAction } from "react";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import TableCell, { TableCellProps } from "@mui/material/TableCell";
import InsightReportViewModel from "./ViewModels/InsightReportViewModel";
import ScheduleIcon from "./Icons/ScheduleIcon";
import TimePeriodIcon from "./Icons/TimePeriodIcon";
import WarningIcon from '@mui/icons-material/Report';
import Tooltip from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles"
import Typography from '@mui/material/Typography';
import Stack from "@mui/material/Stack";
import { InsightView } from "../ViewModels/InsightView";

interface IInsightTableProps {
    view: InsightView
    reports: InsightReportViewModel[]
    setSelectedReportId: Dispatch<SetStateAction<number>>
}

const InsightTableCell = styled(TableCell)<TableCellProps>(({ theme }) => ({
    padding: theme.spacing(1.5)
}))

export default function InsightTable({ view, reports, setSelectedReportId }: IInsightTableProps) {
    return (
        <>
            <TableContainer style={{ height: '100%', overflowY: 'scroll' }} >
                <Table stickyHeader >
                    <TableHead>
                        <TableRow>
                            {view === InsightView.Agent && <InsightTableCell>Agent Name</InsightTableCell>}
                            <InsightTableCell>Insight Name</InsightTableCell>
                            <InsightTableCell>Channel</InsightTableCell>
                            <InsightTableCell>Schedule</InsightTableCell>
                            <InsightTableCell>Time Period</InsightTableCell>
                            <InsightTableCell>Date</InsightTableCell>
                            {(view === InsightView.Agent || view === InsightView.Operational) && <InsightTableCell>Week Number</InsightTableCell>}
                            {(view === InsightView.Agent || view === InsightView.Operational) && <InsightTableCell>Team Manager</InsightTableCell>}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            reports.map(report => {
                                const displayWarning = !(report.status === null || report.status === undefined || report.status === "Active" || report.status === "Finalised");
                                const warningSx = displayWarning ? { fontStyle: 'italic', opacity: 0.4 } : undefined;

                                const onRowClick = () => {
                                    setSelectedReportId(report.id);
                                }

                                return (
                                    <TableRow {...(displayWarning ? { sx: { backgroundColor: '#e0e0e04a' } } : { onClick: onRowClick })}>
                                        {view === InsightView.Agent &&
                                            <InsightTableCell sx={warningSx}>{report.agentName}</InsightTableCell>
                                        }
                                        <InsightTableCell>
                                            <Stack direction="row" spacing={1}>
                                                <Typography sx={warningSx}>
                                                    {(view === InsightView.Agent || view === InsightView.Operational)
                                                        ? report.template
                                                        : report.insightName}
                                                </Typography>
                                                {displayWarning &&
                                                    <Tooltip title={report.status}>
                                                        <WarningIcon color='error' sx={{ verticalAlign: 'middle' }} />
                                                    </Tooltip>
                                                }
                                            </Stack>
                                        </InsightTableCell>
                                        <InsightTableCell sx={warningSx}>{report.channel}</InsightTableCell>
                                        <InsightTableCell sx={warningSx}>
                                            <ScheduleIcon schedule={report.schedule} />
                                        </InsightTableCell>
                                        <InsightTableCell sx={warningSx}>
                                            <TimePeriodIcon timePeriod={report.timePeriod} />
                                        </InsightTableCell>
                                        <InsightTableCell sx={warningSx}>
                                            {
                                                report.timePeriod === 'Day'
                                                    ? report.startDate
                                                    : `${report.startDate} - ${report.endDate}`
                                            }
                                        </InsightTableCell>
                                        {(view === InsightView.Agent || view === InsightView.Operational) && <InsightTableCell sx={warningSx}>{report.weekNumber}</InsightTableCell>}
                                        {(view === InsightView.Agent || view === InsightView.Operational) && <InsightTableCell sx={warningSx}>{report.teamManager}</InsightTableCell>}
                                    </TableRow>)
                            })
                        }
                    </TableBody>
                </Table >
            </TableContainer >
        </>
    );
};
